import React from "react";
import { Checkbox, Space } from "antd";
import { UNIVERSAL_TOPICS } from "../topicConfig";

interface Props {
    selectedTopics: string[];
    onChange: (topics: string[]) => void;
}

const UniversalTopicStep: React.FC<Props> = ({ selectedTopics, onChange }) => {
    const handleToggle = (topicId: string) => {
        if (selectedTopics.includes(topicId)) {
            onChange(selectedTopics.filter((t) => t !== topicId));
        } else {
            onChange([...selectedTopics, topicId]);
        }
    };

    return (
        <div>
            <h3>Universal Research Topics</h3>
            <p style={{ marginBottom: 16, opacity: 0.7 }}>
                Select the research areas you'd like covered in your brief.
            </p>
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
                {UNIVERSAL_TOPICS.map((topic) => (
                    <Checkbox
                        key={topic.id}
                        checked={selectedTopics.includes(topic.id)}
                        onChange={() => handleToggle(topic.id)}
                    >
                        <strong>{topic.label}</strong>
                        <br />
                        <span style={{ opacity: 0.7, fontSize: 12 }}>{topic.description}</span>
                    </Checkbox>
                ))}
            </Space>
        </div>
    );
};

export default UniversalTopicStep;
